import { render } from "./partial-card-list-sort.vue?vue&type=template&id=667fd6c4&ts=true"
import script from "./partial-card-list-sort.vue?vue&type=script&lang=ts"
export * from "./partial-card-list-sort.vue?vue&type=script&lang=ts"

import "./partial-card-list-sort.vue?vue&type=style&index=0&id=667fd6c4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__